import { fetchPostDetail, fetchPosts } from './community';

export const PUSH_POST_LIMIT = 10;
const isPostId = (value) => /^\d{1,20}$/.test(value) && BigInt(value) > 0 && BigInt(value) <= BigInt('18446744073709551615');
export const isPublishedPost = (post) => post && ['1', 'PUBLISHED'].includes(String(post.status))
    && ['1', '2'].includes(String(post.categoryId));
const checked = async (pending) => {
    const result = await pending;
    if (!result) throw new Error('文章查询失败，请检查登录状态和文章查看权限。');
    return result;
};

export const getPushPost = async (id) => {
    if (!isPostId(id)) return null;
    try { return await checked(fetchPostDetail(id)); }
    catch (error) {
        if (error.response?.status === 404) return null;
        throw error;
    }
};

// Article has a title; a Post usually has only content. Both use post.id.
// Do not apply the Article-only category filter used by the article list screen.
export const searchPushPosts = async (value) => {
    const keyword = value.trim();
    const params = { 'page.num': 1, 'page.size': PUSH_POST_LIMIT, status: '1' };
    if (!keyword) return (await checked(fetchPosts(params))).list?.filter(isPublishedPost).slice(0, PUSH_POST_LIMIT) || [];
    // A digit sequence can be an ID fragment, not an existing article. Use the
    // list endpoint instead of letting a missing detail request fail the search.
    if (/^\d+$/.test(keyword)) {
        const result = await checked(fetchPosts({ ...params, keyword }));
        return (result.list || []).filter(isPublishedPost)
            .sort((a, b) => Number(b.id === keyword) - Number(a.id === keyword))
            .slice(0, PUSH_POST_LIMIT);
    }
    const [titles, posts] = await Promise.all([
        checked(fetchPosts({ ...params, title: keyword })),
        checked(fetchPosts({ ...params, categoryId: '1', content: keyword })),
    ]);
    const matches = new Map();
    for (const post of [...(titles.list || []), ...(posts.list || [])]) {
        if (isPublishedPost(post) && !matches.has(post.id)) matches.set(post.id, post);
    }
    return [...matches.values()].slice(0, PUSH_POST_LIMIT);
};
